import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class AbortedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            memohistory:[],
            isLoading: false
        };
        
    }
    componentDidMount(){
        this.setState({isLoading: true});
        return fetch('/api/v1/portal/portal-admin/memo-history', {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({
                memohistory: response.history,
                isLoading: false
              })
            });
        });
    }
    renderPortalAccountNotifications() {
        let MemoNotifications = [];
        if (this.state.memohistory.length > 0) {
          this.state.memohistory.forEach(function(i,index) {
            MemoNotifications.push(
              <><div key={"job-"+index+"-notification-"+i.id} className="row">
                <div dangerouslySetInnerHTML={{__html: i.message}} className="col-md-8 text-left"></div>
                <div className="col-md-4">
                  <span className="small sidebar-time">{i.sidebar_time}</span>
                </div>
              </div><hr /></>);
          });
        }else{
            MemoNotifications.push(
                <div key={"no-records"}>
                  No Records Found!
                </div>);
        }
    
        return (
          <div className="jobs-table-job-notifications-container">{MemoNotifications}</div>
        )
      }
    render() {
        
        return (
            <div className="container-fluid">
                
                <div className="row">
                    <div className="col-md-2">&nbsp;</div>
                    <div className="col-md-8">
                        <h2>History</h2>
                        <br/>
                    </div>
                    <div className="col-md-2">&nbsp;</div>
                    <div className="col-md-2">&nbsp;</div>
                    <div className="col-md-8">
                        <div className="portal-admin-table-full-details-column-container">
                            <h3>Memo Activity</h3>
                            <div>
                                {this.state.isLoading ? 
                                <span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span>
                                 : 
                                 this.renderPortalAccountNotifications()}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">&nbsp;</div>
                </div>
                <br/><br/><br/>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-my-account-memo-history')) {
    ReactDOM.render(
        <AbortedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-my-account-memo-history')
    );
}
